import React, { useMemo } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { renderImage, SEARCH_THUMBNAIL_IMAGE } from 'helpers/ImageHelper';
import Style from '../../Styles/FindTile.module.scss';

const FindTile = ({ account, breakpoint, item, itemIndex, processor, searchProps }) => {
  const { image, altText, link, title, episodeCount, onClick } = processor({
    account,
    item,
    searchProps,
  });

  const findTileImg = useMemo(
    () => (
      <div className={Style.imageContainer}>
        {renderImage({
          breakpoint,
          imageType: SEARCH_THUMBNAIL_IMAGE,
          alt: altText,
          src: image,
        })}
      </div>
    ),
    [altText, breakpoint, image],
  );

  const findTileBody = useMemo(
    () => (
      <div className={Style.titleContainer}>
        <div className={Style.title}>{title}</div>
        {episodeCount !== 0 && <span className={Style.episodeCount}>({episodeCount})</span>}
      </div>
    ),
    [episodeCount, title],
  );

  return (
    <div key={itemIndex}>
      <Link aria-label={title} className={Style.imageContainer} onClick={onClick} to={link}>
        {findTileImg}
      </Link>
      {findTileBody}
    </div>
  );
};

export default FindTile;

FindTile.propTypes = {
  account: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
  item: PropTypes.shape({}),
  itemIndex: PropTypes.number,
  processor: PropTypes.func,
  searchProps: PropTypes.shape({}),
};
